module.exports = __webpack_public_path__ + "img/hot.57446bf3.png";